import * as React from "react";
const IconSent = (props) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.08887 1.95292L21.6567 9.23242C23.9325 10.3696 23.9325 13.6153 21.6567 14.7524L7.08886 22.0319C4.49787 23.3267 1.70997 20.6642 2.88648 18.0187L5.00909 13.2457C5.05004 13.1536 5.08626 13.06 5.11776 12.9653L10.392 12.9653C10.9293 12.9653 11.3649 12.5297 11.3649 11.9924C11.3649 11.4551 10.9293 11.0196 10.392 11.0196L5.11776 11.0196C5.08627 10.9248 5.05004 10.8313 5.00909 10.7392L2.88648 5.96619C1.70997 3.32065 4.49787 0.658209 7.08887 1.95292Z"
      fill={props.color || "#1C1C2C"}
    />
  </svg>
);
export default IconSent;
